<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps({
  width: { type: Number, default: 1120 }
});

const outer = ref(null);
const inner = ref(null);
const scale = ref(0.3);
const height = ref(0);
let observer = null;

function measure() {
  if (!outer.value || !inner.value) return;
  scale.value = outer.value.clientWidth / props.width;
  height.value = inner.value.offsetHeight * scale.value;
}

onMounted(() => {
  measure();
  observer = new ResizeObserver(measure);
  observer.observe(outer.value);
  observer.observe(inner.value);
});

onBeforeUnmount(() => observer?.disconnect());
</script>

<template>
  <div ref="outer" class="scaled" :style="{ height: `${height}px` }">
    <div ref="inner" class="inner" :style="{ width: `${width}px`, transform: `scale(${scale})` }">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.scaled {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.inner {
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: top left;
}
</style>
